module.exports = __webpack_public_path__ + "img/00011.7ba23449.webp";